import styled from '@emotion/styled';
import React from 'react';

import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { useNavigate } from '../../../../../shared/router/useNavigate';
import { Color } from '../../../../../shared/styles/Color';
import { theme } from '../../../../../shared/styles';

interface IBookingSummaryChangeButtonProps {
	url: string;
}

export const BookingSummaryChangeButton = ({
	url,
}: IBookingSummaryChangeButtonProps) => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const onButtonClick = () => {
		navigate(url);
	};

	return (
		<StyledButton type="button" onClick={onButtonClick}>
			{t('web_booking_summary_change')}
		</StyledButton>
	);
};

const StyledButton = styled.button`
	background: none;
	border: none;
	background: transparent;
	outline: none;
	margin-left: auto;
	font-size: 16px;
	font-weight: 500;
	color: ${Color.PrimaryDefault};
	padding: 0;
	cursor: pointer;
	font-family: inherit;

	&:focus-visible {
		outline: ${theme.button?.primary?.focus?.outline};
		border-radius: 2px;
	}
`;
